import { useListarTorres } from "services/api";
import React, { useState } from "react";
import EspelhoVendasModal from "components/dialogCommon/templates/EspelhoVendasModal";
import ModalFulscreen from "components/ModalFullscreen";
import SelectComponent from "../../../../../../components/selectAutoCompleteG";
import * as Styles from "./style";
import * as SVGIcons from "../../../../../../assets/iconsSVG";

interface Props {
  idCorretor2013?: string;
  product?: any;
  data?: any;
}

interface ProductSelectProps {
  value: string;
  label: string;
  codigoSap: string;
}

interface SelectProps {
  value: string;
  label: string;
}

interface DataProps {
  bandeira: SelectProps;
  bloco: SelectProps;
  produto: ProductSelectProps;
  blocosData: any;
}

export default function ModalEspelho(props: Props) {
  const [block, setBlock] = useState<any>([] || null);
  // const [espelhoLink, setEspelhoLink] = useState<string>(
  //   `https://pvcrm.cyrela.com.br/secretaria/FrmEmpreendimento.aspx?userid=${props.idCorretor2013}&tipoUrl=6`
  // );
  const [espelhoVendasModal, setEspelhoVendasModal] = useState(false);

  const {
    data: blocosData,
    refetch: blocosRefetch,
    status: blocosStatus,
  } = useListarTorres({
    idEmpreendimento: props.product,
    queryKey: "listar-blocos",
  });

  // useEffect(() => {
  //   if (block && block.value && props.product) {
  //     setEspelhoLink(
  //       `https://pvcrm.cyrela.com.br/secretaria/FrmEspelhoVenda.aspx?id=${props.product}&ambiente=6&idBloco=${block.value}&sec=N&dt=N`
  //     );
  //   } else {
  //     setEspelhoLink(
  //       `https://pvcrm.cyrela.com.br/secretaria/FrmEmpreendimento.aspx?userid=${props.idCorretor2013}&tipoUrl=6`
  //     );
  //   }
  // }, [block, props.product]);

  React.useEffect(() => {
    blocosRefetch();
    setBlock([]);
  }, [props.product]);

  const newData: DataProps = {
    bandeira: props.data?.nomeBandeira || { value: "", label: "" },
    produto: {
      value: props?.data?.idEmpreendimento || "",
      label: props?.data?.nomeEmpreendimento || "",
      codigoSap: props?.data?.codigoSap || "",
    },
    bloco: block || { value: "", label: "" },
    blocosData,
  };

  return (
    <Styles.Container>
      <SelectComponent
        label="Blocos"
        borderRadius="8px"
        data={
          blocosStatus === "success"
            ? blocosData?.data?.map((item: any) => ({
                label: item?.nome,
                value: item?.id,
              }))
            : []
        }
        disabled={!(blocosStatus === "success")}
        onChange={(event: { label: string; value: string }) => {
          setBlock(event);
        }}
        value={block}
        isMultiple={false}
      />
      <Styles.SpaceY space={40} />
      <Styles.GradientButton
        disabled={!block || block.length === 0}
        onClick={() => setEspelhoVendasModal(true)}
      >
        Abrir espelho <SVGIcons.SharedIcon style={{ marginLeft: 8 }} />
      </Styles.GradientButton>
      <ModalFulscreen
        open={espelhoVendasModal}
        setOpenModal={() => setEspelhoVendasModal(true)}
        onClose={() => setEspelhoVendasModal(false)}
      >
        <EspelhoVendasModal
          data={newData}
          onClose={() => setEspelhoVendasModal(false)}
          idLead={undefined}
          openOpportunityForm={() => {}}
        />
      </ModalFulscreen>
    </Styles.Container>
  );
}
